// extracted by mini-css-extract-plugin
export default {"first-column":"InsightsTable_first-column_FIvFM"};